(function () {
    'use strict';

    a3_cabin_reports.directive('additionalTrainingReadOnly', additionalTrainingReadOnly);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name additionalTrainingReadOnly
    * @restrict E
    * @description
    *    Implementation of additional Training ReadOnly
    * @example
    *   Usage:
    *   <additional-training-read-only></additional-training-read-only>
    * @ngInject
    */
    function additionalTrainingReadOnly() {
        function link(scope, element, attrs) {
        }

        return {
            restrict: 'E',
            terminal: true,
            templateUrl: 'views/TrainingReadOnly/additional-training-read-only.tpl.html',
            scope: { traineeSession: "=" },
            link: link
        }
    }

})();
